import { render, staticRenderFns } from "./AudienceRule.vue?vue&type=template&id=0b122810&scoped=true&"
import script from "./AudienceRule.vue?vue&type=script&lang=js&"
export * from "./AudienceRule.vue?vue&type=script&lang=js&"
import style0 from "./AudienceRule.vue?vue&type=style&index=0&id=0b122810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b122810",
  null
  
)

export default component.exports